import classNames from "classnames";
import React from "react";
import { Spinner } from "reactstrap";

import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Alert, Button, Text } from "@mantine/core";
import { openContactUsForm } from "@/components/ContactUsForm/ContactUsForm";
import { closeModal } from "@mantine/modals";
import { ThemedButton } from "@/components/ThemedButton";

export const CheckoutSidebar = ({
	isSticky = true,
	loading,
	onCheckout,
	calculatedPrice,
	checkoutError,
}) => {
	const [animatedRef, enableAnimations] = useAutoAnimate({
		easing: "linear",
	});
	const handleOpenContactForm = () => {
		const modalId = openContactUsForm({
			onSuccess: () => {
				closeModal(modalId);
			},
		});
	};

	const handleCheckout = () => {
		if (loading) {
			return;
		}
		onCheckout();
	};

	return (
		<div style={{ height: "100%" }}>
			<div
				style={{ position: isSticky ? "sticky" : "static", top: 30, zIndex: 100 }}
				className={classNames("card", "shadow-none", "p-4")}>
				<h6 className='mb-4 fs18'>Order Summary</h6>
				{calculatedPrice ? (
					<>
						<div className='d-flex flex-column ' ref={animatedRef}>
							{calculatedPrice?.lines?.map((x) => {
								return (
									<div className='d-flex justify-content-between gap-2' key={x.name}>
										<Text size='sm'>{x.name}:</Text>
										<Text size='sm' fw='bold'>
											{x.subtotal ? `SGD ${x.subtotal.toFixed(2)}` : "Free"}
										</Text>
									</div>
								);
							})}
						</div>
						<div className='d-flex flex-column gap-0 mt-4'>
							{[
								{
									label: "Subtotal",
									value: calculatedPrice.subtotal,
								},
								{
									label: `GST (${calculatedPrice.gst_percent}%)`,
									value: calculatedPrice.gst_amount,
								},
							].map((x) => {
								return (
									<div className='d-flex justify-content-between' key={x.label}>
										<Text size='sm'>{x.label}</Text>
										<Text size='sm' fw='bold'>
											${x.value.toFixed(2)}
										</Text>
									</div>
								);
							})}
							<div
								className='card shadow-none p-2 rounded rounded-sm mt-4'
								style={{
									backgroundColor: "#efefef",
								}}>
								<div className='d-flex justify-content-between'>
									<Text size='sm'>Total:</Text>
									<Text size='sm' fw='bold'>
										{calculatedPrice.total_amount
											? "SGD " + calculatedPrice.total_amount.toFixed(2)
											: "Free"}
									</Text>
								</div>
							</div>
						</div>
					</>
				) : (
					<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}></div>
				)}

				{checkoutError ? (
					<Alert color='green' radius='sm' mt={10} title={"💡 " + checkoutError}></Alert>
				) : // <div className='d-flex align-items-center gap-2 justify-content-start alert alert-info rounded rounded-sm text-color-dark'>
				// 	<span>💡 {checkoutError}</span>
				// </div>
				null}

				{!checkoutError && calculatedPrice ? (
					loading ? (
						<ThemedButton disabled={true} onClick={handleCheckout}>
							<div className='d-flex align-items-center gap-2 justify-content-center'>
								<span>Calculating Price...</span>
							</div>
						</ThemedButton>
					) : (
						<ThemedButton disabled={loading} onClick={handleCheckout}>
							<div className='d-flex align-items-center gap-2 justify-content-center'>
								{loading && <Spinner size='sm' />}
								<span>
									{calculatedPrice?.total_amount ? "Proceed to Payment" : "Complete Order"}
								</span>
							</div>
						</ThemedButton>
					)
				) : null}

				<Text c='gray' size='sm' mt='md'>
					Need help?{" "}
					<Text
						span
						c='blue'
						size='sm'
						onClick={handleOpenContactForm}
						style={{ cursor: "pointer" }}>
						Contact us here.
					</Text>
				</Text>
			</div>
		</div>
	);
};
